module.exports = __webpack_public_path__ + "img/popup_button_normal_ok.f7642712.png";